<template>
  <div style="background-color: white"
       :class="{'running-out-yellow': isRunningOutYellow, 'running-out-orange': isRunningOutOrange}"
       v-if="this.date > this.now">
    <div>
      <div v-if="statusleilao_id === 17"> <!-- Leilão de crédito só exibir relógio quando entrar em pregão -->
        <!-- statuslote_id === 2 || statuslote_id === 3 || statuslote_id === 6 || statuslote_id === 11 || statuslote_id === 12 || statuslote_id === 14 -->
        <div class="countdown"
             v-if="statuslote_id === 'Em Pregão'   || statuslote_id === 'Dou-lhe Duas'      ||
                  statuslote_id === 'Repasse'     || statuslote_id === 'Repasse com Lance' ||
                  statuslote_id === 'Dou-lhe Uma' || statuslote_id === 'Dou-lhe Três'">
          <div class="block">
            <p class="digit">{{ days.toString().length === 1 ? '0' + days + 'd' : days + 'd' }}</p>
            <p class="label-prefix">dias</p>
          </div>
          <div class="block">
            <p class="digit">{{ hours.toString().length === 1 ? '0' + hours + 'h' : hours + 'h' }}</p>
            <p class="label-prefix">horas</p>
          </div>
          <div class="block">
            <p class="digit">{{ minutes.toString().length === 1 ? '0' + minutes + 'm' : minutes + 'm' }}</p>
            <p class="label-prefix">minutos</p>
          </div>
          <div class="block">
            <p class="digit">{{ seconds.toString().length === 1 ? '0' + seconds + 's' : seconds + 's' }}</p>
            <p class="label-prefix">segundos</p>
          </div>
        </div>
        <div v-else>
          <div class="block">
            <p class="digit">- Aguarde -</p>
          </div>
        </div>
      </div>
      <div class="countdown" v-else>
        <div class="block">
          <p class="digit">{{ days.toString().length === 1 ? '0' + days + '' : days + '' }}</p>
          <p class="label-prefix">dias</p>
        </div>
        <div class="block">
          <p class="digit">{{ hours.toString().length === 1 ? '0' + hours + '' : hours + '' }}</p>
          <p class="label-prefix">horas</p>
        </div>
        <div class="block">
          <p class="digit">{{ minutes.toString().length === 1 ? '0' + minutes + '' : minutes + '' }}</p>
          <p class="label-prefix">minutos</p>
        </div>
        <div class="block">
          <p class="digit">{{ seconds.toString().length === 1 ? '0' + seconds + 's' : seconds + 's' }}</p>
          <p class="label-prefix">segundos</p>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div id="countdown">
      <p class="text-center">- &nbsp; -</p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

Vue.filter('twoDigits', (value) => {
  if (value.toString().length <= 1) {
    return '0' + value.toString()
  }
  return value.toString()
})
let interval = null;

export default {
  //props: ['deadline', 'stop', 'statusleilao_id', 'statuslote_id'],
  props: {
    'deadline': {default: 0},
    'stop': {default: 0},
    'statusleilao_id': {default: 0},
    'statuslote_id': {default: 0}
  },
  data() {
    return {
      now: 0,
      date: null,
      diff: 0,
      dateTratado: null,
      isRunningOutYellow: false,
      isRunningOutOrange: false
    }
  },
  methods: {
    is_safari() {
      var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
      var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      return isSafari || iOS
    },
    formatDate() {
      var self = this;

      let deadline = String(self.deadline).replace(/\s/, 'T');

      if (self.is_safari()) {
        if (deadline.length > 19) {
          deadline = deadline.substring(0, 19);
        }
        let d = new Date(deadline);
        self.date = Math.trunc(d.getTime() / 1000);
      } else {
        self.date = Math.trunc(new Date(deadline).getTime() / 1000);
      }
    },
    interval() {
      var self = this
      var iniTime = localStorage.getItem('ts')
      var dateAnt = localStorage.getItem('tsAnt')
      var d = new Date();
      var diffInMs = 0;
      var diff = 0;
      var dataAtual = new Date(self.$time);
      var timeDifFormat = (dataAtual.getTimezoneOffset() / (-60));

      diffInMs = d.getTime() - dateAnt;
      diff = Math.trunc((diffInMs / (1000)));
      dateAnt = d;

      // if((diff > 50 || diff < 0) || iniTime != timeDifFormat) {
      //   this.$router.go();
      // }

      localStorage.setItem('ts', timeDifFormat);
      localStorage.setItem('tsAnt', d.getTime());

      self.now = Math.trunc(dataAtual.getTime() / 1000)
    }
  },
  mounted() {
    if (this.deadline) {
      this.formatDate();
      interval = setInterval(this.interval, 1000);
    }
  },
  computed: {
    seconds() {
      return Math.trunc(this.diff) % 60
    },

    minutes() {
      return Math.trunc(this.diff / 60) % 60
    },

    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24
    },

    days() {
      return Math.trunc(this.diff / 60 / 60 / 24)
    }
  },
  watch: {
    now() {
      this.diff = this.date - this.now
      if (this.diff <= 0 || this.stop) {
        this.diff = 0;
      }

      this.isRunningOutYellow = this.statuslote_id === "Dou-lhe Uma" || this.statuslote_id === 12;
      this.isRunningOutOrange = this.statuslote_id === "Dou-lhe Duas" || this.statuslote_id === 3;
    },

    deadline: function () {
      this.formatDate();
      interval = setInterval(this.interval, 1000);
    }
  }
}
</script>
<style scoped>
.countdown {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Ubuntu', sans-serif !important;
}

.block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 7px 20px 7px !important;
}

.digit,
.label-prefix {
  color: black !important;
  margin: 0 0 -2px 0 !important;
}

.digit {
  font-size: 24px;
  font-weight: 800 !important;
}

.label-prefix {
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 900;
}

.running-out-yellow {
  animation: blink1 1s linear infinite;
}

.running-out-orange {
  animation: blink2 1s linear infinite;
}

@keyframes blink1 {
  0% {
    background-color: #fff;
  }
  50% {
    background-color: #e6d48a;
  }
  100% {
    background-color: #fff;
  }
}

@keyframes blink2 {
  0% {
    background-color: #fff;
  }
  50% {
    background-color: #e6aa8a;
  }
  100% {
    background-color: #fff;
  }
}

@media (max-width: 991px) {
  .digit {
    font-size: 19px;
  }

  .label-prefix {
    font-size: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Countdown.vue